import { render, staticRenderFns } from "./cabinetCard.vue?vue&type=template&id=29755d1a&scoped=true&"
import script from "./cabinetCard.vue?vue&type=script&lang=js&"
export * from "./cabinetCard.vue?vue&type=script&lang=js&"
import style0 from "./cabinetCard.vue?vue&type=style&index=0&id=29755d1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29755d1a",
  null
  
)

export default component.exports